import { type ReactNode } from 'react';
import type { Callback } from 'ts/base/Callback';
import { Form, FormGroup, FormRadio } from 'ts/components/Form';
import { Segment } from 'ts/components/Segment';
import type { DiffDescription } from 'typedefs/DiffDescription';

/** Allows to select between the possible diff modes. */
export function DiffModeForm({
	diffs,
	diffIndex,
	onDiffModeChanged,
	coverageSelector
}: {
	diffs: DiffDescription[];
	diffIndex: number;
	onDiffModeChanged: Callback<number>;
	coverageSelector?: ReactNode;
}) {
	return (
		<Segment>
			<Form className="flex">
				{diffs.length > 1 ? (
					<FormGroup inline className="!mb-0" as="fieldset" aria-labelledby="comparison-mode-legend">
						{/* Workaround for a Chrome bug https://stackoverflow.com/a/59425373 */}
						<div id="comparison-mode-legend" className="mr-2 font-bold">
							Comparison mode:
						</div>
						{diffs.map((diff, index) => (
							<FormRadio
								key={index}
								name="type"
								id={`radio-type-${index}`}
								checked={index === diffIndex}
								label={diff.name}
								onChange={() => onDiffModeChanged(index)}
							/>
						))}
					</FormGroup>
				) : null}
				{coverageSelector}
			</Form>
		</Segment>
	);
}
